import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/chigua';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (id: string) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="sticky top-0 z-50 w-full">
      <div
        className={`transition-all duration-300 ${
          scrolled
            ? 'bg-paper-50/90 backdrop-blur-md border-b border-paper-200'
            : 'bg-transparent'
        }`}
      >
        <div className="mx-auto flex h-16 w-full items-center justify-between px-4 md:px-6 max-w-[1200px]">
          <a
            href="#top"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className="group flex items-center gap-3"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-ink-900 text-paper-50 transition-colors group-hover:bg-accent-600">
              <i className="ri-leaf-line text-lg" />
            </span>
            <span className="font-heading text-xl font-bold tracking-wide text-ink-900">
              98吃瓜
            </span>
          </a>

          <nav className="hidden items-center gap-1 md:flex">
            {navLinks.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  go(l.id);
                }}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-ink-700 transition-colors hover:bg-paper-100 hover:text-accent-600"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-3 md:flex">
            <a
              href="#subscribe"
              onClick={(e) => {
                e.preventDefault();
                go('subscribe');
              }}
              className="whitespace-nowrap rounded-md bg-accent-600 px-4 py-2 text-sm font-medium text-paper-50 transition-colors hover:bg-accent-700"
            >
              订阅脉络速递
            </a>
          </div>

          <button
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-ink-900 hover:bg-paper-100 md:hidden"
            aria-label="打开导航菜单"
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-2xl`} />
          </button>
        </div>

        {open && (
          <div className="border-t border-paper-200 bg-paper-50/95 px-4 pb-4 pt-2 backdrop-blur-md md:hidden">
            {navLinks.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  go(l.id);
                }}
                className="block whitespace-nowrap rounded-md px-3 py-3 text-sm text-ink-700 hover:bg-paper-100 hover:text-accent-600"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={(e) => {
                e.preventDefault();
                go('subscribe');
              }}
              className="mt-2 block whitespace-nowrap rounded-md bg-accent-600 px-4 py-3 text-center text-sm font-medium text-paper-50"
            >
              订阅脉络速递
            </a>
          </div>
        )}
      </div>
    </header>
  );
}